import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const ProtectedRoute = ({ children, allowedRole }) => {
    const { isLoaded, isSignedIn, user } = useUser();

    // Show loading while checking authentication
    if (!isLoaded) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: '#0f172a',
                color: '#fff'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid rgba(255, 255, 255, 0.1)',
                        borderTopColor: '#4F46E5',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 16px'
                    }}></div>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    // Redirect to sign-in if not authenticated
    if (!isSignedIn) {
        // Store the intended role
        sessionStorage.setItem('selectedRole', allowedRole);
        return <Navigate to="/sign-in" replace />;
    }

    // Get user's role from Clerk metadata
    const userRole = user.publicMetadata?.role || user.unsafeMetadata?.role;

    // Check if user just assigned this role (stored temporarily during signup)
    // Check if user just assigned this role (stored temporarily during signup)
    const justAssignedRole = sessionStorage.getItem('justAssignedRole');

    const isRoleAllowed = Array.isArray(allowedRole)
        ? allowedRole.includes(userRole)
        : userRole === allowedRole;

    const isJustAssigned = Array.isArray(allowedRole)
        ? allowedRole.includes(justAssignedRole)
        : justAssignedRole === allowedRole;

    // If user just assigned this role, allow access and clear the flag
    if (isJustAssigned) {
        sessionStorage.removeItem('justAssignedRole');
        return children;
    }

    // Check if user has the allowed role
    if (!isRoleAllowed) {
        // User has a different role, redirect to their dashboard
        if (userRole && userRole !== 'citizen') {
            return <Navigate to={`/${userRole}-dashboard`} replace />;
        }

        // No role assigned, redirect to role selection
        return <Navigate to="/" replace />;
    }

    // User has the correct role, render the protected content
    return children;
};

export default ProtectedRoute;
